import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

const ListActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3)
}))

export default ListActions
